import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Setting } from '../../shared/models/setting.model';

import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class SettingService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;

	constructor(private http: HttpClient) { }

	// getAll() {
	// 	return this.http.get<Setting[]>(`${this.apiUrl}/api/settings`);
	// }

	getAll() {
		return {
			"id": 1,
			"company_name": "InsiderSys",
			"company_legal_name": null,
			"company_short_name": "InsiderSys",
			"contact_person": null,
			"company_address": "balaji wind third floor",
			"company_country": null,
			"company_city": null,
			"company_zipcode": null,
			"company_phone": null,
			"company_email": "info@insiderSys.com",
			"company_website": null,
			"company_from_email": "info@insiderSys.com",
			"post_mark": false,
			"smtp_protocol": null,
			"smtp_host": null,
			"smtp_user": null,
			"smtp_password": null,
			"smtp_port": null,
			"smtp_encryption": null,
			"sparkpost_secret": null,
			"mailgun_domain": null,
			"mailgun_secret": null,
			"mandrill_secret": null,
			"active_cronjob": false,
			"automatic_backup": false,
			"daily_report_emails": null,
			"last_autobackup": "0",
			"cronjob_link": null,
			"last_cronjob_run": null,
			"login_background": null,
			"company_logo": null,
			"company_sidebar_logo": null,
			"sidebar_background_images": null,
			"default_language": "en",
			"default_locale": null,
			"timezone": "Asia/Kolkata",
			"tables_pagination_limit": 10,
			"date_format": "YYYY-MM-DD",
			"time_format": "hh:mm A",
			"date_time_format": "YYYY-MM-DD hh:mm A",
			"currency_id": 16,
			"purchase_key": null,
			"unique_coder": null,
			"update_url": null,
			"theme_layout": "light",
			"sidebar_bg_color": "white",
			"sidebar_transparent_bg_image": "bg_glass_1",
			"sidebar_bg_custom_color": "#000000",
			"sidebar_font_color": "black",
			"sidebar_width": "small",
			"sidebar_bg_image": 0,
			"product_version": "2.1",
			"allowed_for_registration": true,
			"created_at": "2025-01-24 06:25:17",
			"updated_at": "2025-05-05 01:22:59",
			"_demo": false,
			"_announcement_notification": true,
			"_collapsed_menu": true,
			"_sidebar_background": false
		};
	}

	// getSettings(){
	// 	return this.http.get<Setting[]>(`${this.apiUrl}/api/settings/get-settings`);
	// }
	getSettings() {
		return {
			"login_background": null,
			"company_logo": null,
			"theme_layout": "light",
			"default_language": "en",
			"allowed_for_registration": true,
			"is_demo": false
		}
	}

	getById(id: number) {
		return this.http.get(`${this.apiUrl}/api/settings/${id}`);
	}

	create(setting: Setting) {
		return this.http.post(`${this.apiUrl}/api/settings`, setting);
	}

	delete(id: number) {
		return this.http.delete(`${this.apiUrl}/api/settings/${id}`);
	}

	saveWorkingDays(data) {
		return this.http.post(`${this.apiUrl}/api/working-days`, data);
	}

	sendTestEmail() {
		return this.http.get(`${this.apiUrl}/api/settings/sent-test-email`);
	}

	getWorkingDays() {
		return this.http.get(`${this.apiUrl}/api/working-days`);
	}

	getPaymentGatewaySettings() {
		return this.http.get(`${this.apiUrl}/api/payment-gateway-setting`);
	}

	createPaymentGatewaySettings(setting) {
		return this.http.post(`${this.apiUrl}/api/payment-gateway-setting`, setting);
	}

	getSlackSettings() {
		return this.http.get(`${this.apiUrl}/api/slack-setting`);
	}

	createSlackSettings(setting) {
		return this.http.post(`${this.apiUrl}/api/slack-setting`, setting);
	}

}
